import React from "react";
import { Card, CardContent } from "@/components/ui/card";

export function fmtDuration(sec) {
  const s = Math.max(0, Math.floor(sec || 0));
  if (s === 0) return "—";
  const m = Math.floor(s / 60);
  if (m < 1) return `${s}s`;
  if (m < 60) return `${m} min ${(s % 60).toString().padStart(2, "0")}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${(m % 60).toString().padStart(2, "0")}`;
}

export function KpiCard({ label, value, icon: Icon, color, testid }) {
  return (
    <Card className="border-slate-200 shadow-none">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-1.5">
          <div className="text-[11px] uppercase tracking-widest text-slate-500">{label}</div>
          {Icon && <Icon className="w-4 h-4" style={{ color: color || "#0F172A" }} />}
        </div>
        <div className="font-display font-black text-3xl text-slate-900 tabular-nums" data-testid={testid}>
          {value ?? "—"}
        </div>
      </CardContent>
    </Card>
  );
}

export function ChartCard({ title, children, testid, height = 280 }) {
  return (
    <Card className="border-slate-200 shadow-none" data-testid={testid}>
      <CardContent className="p-5">
        <div className="font-display font-bold text-base text-slate-900 mb-3">{title}</div>
        <div style={{ height, width: "100%" }}>{children}</div>
      </CardContent>
    </Card>
  );
}
